module.exports = __webpack_public_path__ + "static/media/primavera.4a7f0fdc.png";